import Vue from 'vue'
import { emailsService } from '@/_services'

/** Normaliza la respuesta de getAllTemplates (p. ej. 204 sin cuerpo → ""). No tocar handleResponse global. */
function normalizeEmailTemplatesResult(result) {
  if (result == null || result === '') {
    return []
  }
  if (Array.isArray(result)) {
    return result
  }
  return []
}

const getDefaultState = () => {
  return {
    loading: false,
    all: {},
    allFilters: {
      actualQuickFilter: 'ALL',
      salesUserFilter: '',
    },
    selected: {},
    thread: {},
    /** @type {Record<string, Array>} clave: String(link_id) */
    templatesByLinkId: {},
  }
}

// initial state
const state = getDefaultState()

const actions = {
  getAll({ commit }, args) {
    commit('startLoading')
    emailsService
      .getAll(
        args.currentPage,
        args.cantPerPage,
        args.searchFilter,
        args.filters,
        args.targetId,
        state.allFilters.salesUserFilter,
        state.allFilters.clientFilter,
      )
      .then((emails) => {
        commit('getAllSuccess', emails)
        commit('finishLoading')
      })
  },

  getThread({ commit }, args) {
    commit('startLoading')

    emailsService.getThreadById(args.id).then((thread) => {
      commit('getThreadSuccess', thread)
      if (thread !== '') {
        commit('finishLoading')
      }
    })
  },

  getById({ commit }, args) {
    commit('startLoading')

    emailsService.getById(args.id).then((business) => {
      commit('getSelectedSuccess', business)
      if (business !== '') {
        commit('finishLoading')
      }
    })
  },

  getByIdAllSource({ commit }, args) {
    commit('startLoading')

    emailsService.getByIdAllSource(args.id).then((business) => {
      commit('getSelectedSuccess', business)
      if (business !== '') {
        commit('finishLoading')
      }
    })
  },

  startLoading({ commit }) {
    commit('startLoading')
  },

  finishLoading({ commit }) {
    commit('finishLoading')
  },

  startLoadingOpportunities({ commit }) {
    commit('startLoadingOpportunities')
  },

  finishLoadingOpportunities({ commit }) {
    commit('finishLoadingOpportunities')
  },

  resetAllFilters({ commit }) {
    commit('resetAllFilters')
  },

  resetSelected({ commit }) {
    commit('resetSelected')
  },

  resetState({ commit }) {
    commit('resetState')
  },
  setSalesUserFilter({ commit }, args) {
    commit('setSalesUserFilter', args.salesUser)
  },
  setClientFilter({ commit }, args) {
    commit('setClientFilter', args.clientFilter)
  },

  /**
   * Lista de plantillas por link_id; cache en sesión. Si ya existe clave (incl. []), no llama al API.
   * @param {{ linkId: string | number | null | undefined }} payload
   */
  ensureEmailTemplates({ commit, state }, { linkId }) {
    if (linkId == null || linkId === '') {
      return Promise.resolve([])
    }
    const key = String(linkId)
    if (Object.prototype.hasOwnProperty.call(state.templatesByLinkId, key)) {
      return Promise.resolve(state.templatesByLinkId[key])
    }
    return emailsService.getAllTemplates({ link_id: linkId }).then((result) => {
      const templates = normalizeEmailTemplatesResult(result)
      commit('setEmailTemplatesForLink', { linkId: key, templates })
      return templates
    })
  },
}

const mutations = {
  getAllSuccess(state, emails) {
    state.all = { data: emails }
  },
  getSelectedSuccess(state, email) {
    state.selected = { data: email }
  },
  getThreadSuccess(state, emails) {
    state.thread = { data: emails }
  },
  startLoading(state) {
    state.loading = true
  },
  finishLoading(state) {
    state.loading = false
  },
  startLoadingOpportunities(state) {
    state.loadingOpportunities = true
  },
  finishLoadingOpportunities(state) {
    state.loadingOpportunities = false
  },
  resetAllFilters(state) {
    state.allFilters.emailStatusFilter = ''
    state.allFilters.categoryFilter = ''
  },
  resetSelected(state) {
    state.selected = {}
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setSalesUserFilter(state, filter) {
    state.allFilters.salesUserFilter = filter
  },
  setClientFilter(state, filter) {
    state.allFilters.clientFilter = filter
  },
  setEmailTemplatesForLink(state, { linkId, templates }) {
    Vue.set(state.templatesByLinkId, linkId, templates)
  },
}

const getters = {
  /** @returns {Array|undefined} undefined si aún no se cargó para ese link */
  templatesForLink: (state) => (linkId) => {
    if (linkId == null || linkId === '') {
      return undefined
    }
    const key = String(linkId)
    return Object.prototype.hasOwnProperty.call(state.templatesByLinkId, key)
      ? state.templatesByLinkId[key]
      : undefined
  },
  hasTemplatesForLink: (state, getters) => (linkId) => {
    return getters.templatesForLink(linkId) !== undefined
  },
}

export const emails = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
